class StickyHeader {
  constructor() {
    this.process();

    $(window).scroll(() => {
      this.process();
    });
  }

  process() {
    if ($(document).width() > 991) {
      if ($(document).scrollTop() < 75) {
        $('[data-main-header]').removeClass("sticky");
      } else {
        $('[data-main-header]').addClass("sticky");
      }
    }
  }
}

function addRedirectUrls() {
  $('[data-add-redirect-url]').each(function() {
    const href = $(this).attr('href');
    $(this).attr('href', `${href}?redirectFrom=${encodeURIComponent(window.location.href)}`);
  });
}

class FormButtons {
  formWidth = 1100;
  formHeight = 650;
  formSelector = '[data-popup-contact]';

  constructor() {
    const _this = this;

    $(document).on('click', _this.formSelector, function(e, el) {
      e.preventDefault();
      window.open($(this).attr('href'), '_blank', `width=${_this.formWidth},height=${_this.formHeight}`);
    });
  }
}

class HeadMenu {

  constructor() {
    this.$mobileBtn = $('[data-mobile-menu-button]');
    this.$menu = $('[data-head-menu]');
    this.$mobileMenu = $('[data-mobile-menu]');

    this.addEvents();
    this.addImageClass();
    this.addActiveClass();
    this.mobilemenu();
    this.mobileSubmenuDisplay();
  }

  addEvents() {
    const _this = this;
    this.$mobileBtn.on('click', () => {
      this.$mobileBtn.toggleClass('open');
      this.$mobileMenu.toggleClass('open');
      this.$menu.find(' > li').toggleClass('open');
    });

    $('[data-head-menu-expand]').click(function() {
      if (!isMobile()) return;
      _this.toggleMobileMenu($(this));
    });

    $('[data-head-menu-desktop-expand]').click(function(e) {
      if (isMobile()) return;
      e.preventDefault();
      e.stopPropagation();
      _this.toggleDesktopMenu($(this));
    });

    $('.headMenu__level-3__wrapper').click(function(e) {
      e.stopPropagation();
    })

    $(document).click(function() {
      _this.hideDesktopMenu();
    });
  }

  toggleMobileMenu($btn) {
    const $submenu = $btn.closest('.headMenu__expandableItem').next();
    if ($btn.hasClass('expanded')) {
      $btn.removeClass('expanded')
      $submenu.slideUp();
    } else {
      $btn.addClass('expanded')
      $submenu.slideDown();
    }
  }

  toggleDesktopMenu($btn) {
    if ($btn.hasClass('expanded')) {
      this.hideDesktopMenu();
    } else {
      this.hideDesktopMenu();
      this.showDesktopMenu($btn.closest('.headMenu__levelItem'));
    }
  }

  showDesktopMenu($el) {
    $el.addClass('expanded');
    $el.find('> .headMenu__expandableItem').addClass('expanded');
    $el.find('> .headMenu__expandableItem .headMenu__expandableItem__arrow').addClass('expanded');
    setTimeout(() => {
      $el.find('> .headMenu__submenu').fadeIn(300);
    }, 100)
  }

  hideDesktopMenu() {
    if (isMobile()) return;
    const $el = $('.headMenu__levelItem.expanded');
    if ($el.length === 0) return;

    $el.removeClass('expanded');
    $el.find('> .headMenu__expandableItem').removeClass('expanded');
    $el.find('> .headMenu__expandableItem .headMenu__expandableItem__arrow').removeClass('expanded');
    $el.find('> .headMenu__submenu').hide();
  }

  addImageClass() {
    $('.headMenu__submenu').each(function() {
      if ($(this).find('li.withImage').length > 0) {
        $(this).find('li.withImage').parent().addClass('listWithImages')
      }
    });
  }

  addActiveClass() {
    $('.headMenu__mainLink.withSubmenu').each(function() {
      if ($(this).find('a.active').length > 0) {
        $(this).children('a').addClass('active');
      }
    });
  }

  mobilemenu() {
    $('[data-hamburger-button]').click(function() {
      $(this).toggleClass('open');
      $('[data-mobile-menu]').toggleClass('expanded');
    });
  }

  mobileSubmenuDisplay() {
    $('[data-submenu-mobile-button]').click(function() {
      $(this)
        .toggleClass('active')
        .next('.headMenu__submenu')
        .slideToggle();

      $(this).prev('a').toggleClass('expanded');
    });
  }
}

class FooterList {
  constructor() {
    this.toogleSublist();
    this.toggleListContainer();
  }

  toogleSublist() {
    if ($(document).width() < 992) {
      $('[data-show-footer-sublist-button]').click(function() {
        $(this)
          .parent('li')
          .toggleClass('expanded')
          .find('ul')
          .slideToggle();
      });
    }
  }

  toggleListContainer() {
    $('[data-show-links-container-button]').click(function() {
      const _this = $(this);
      _this
        .toggleClass('expanded')
        .parent()
        .prev('[data-links-container]')
        .slideToggle();

      if (_this.hasClass('expanded')) {
        _this.text('Ukryj');
      } else {
        _this.text('Pokaż więcej');
      }
    });
  }
}

function showMoreText() {
  $('[data-show-more-text-button]').click(function() {
    $(this)
      .hide()
      .closest('[data-additional-text-wrapper]')
      .find('[data-text-content]')
      .show();
  });
}

function pageNavScroll() {
  if ($('[data-page-scroll-nav]').length > 0) {
    $('[data-page-scroll-nav] a').click(function(e) {
      e.preventDefault();

      const submenuHeight = $(window).width() > 767 ? 70 : 30;
      const element = $('#' + $(this).attr('href')).find('.e-sectionTitle').length > 0
        ? $('#' + $(this).attr('href')).find('.e-sectionTitle')
        : $('#' + $(this).attr('href'));

      $('html, body').animate({
        scrollTop: element.offset().top - $('[data-main-header]').outerHeight() - submenuHeight
      }, 600);
    })
  }
}

class FbWidget {

  constructor() {
    const _this = this;

    $('[data-fbwidget-btn]').click(function() {
      $(this).parent('.fbWidget').toggleClass('expanded');
    });

  }
}


readyCallbacks.add(() => {
  new StickyHeader();
  addRedirectUrls();
  new FormButtons();
  new HeadMenu();
  new FooterList();
  showMoreText();
  pageNavScroll();
  new FbWidget();

  $('[data-contactform]:not(.initialized)').contactForm();
});
